import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "link pointer"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = ["size"];
const _hoisted_6 = {
  class: "scroll_y flex align_center justify_center"
};
const _hoisted_7 = ["src"];
import { watch, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'YImageView',
  props: {
    simple: {
      type: Boolean,
      default: true
    },
    square: {
      type: Boolean
    },
    size: {
      default: "medium"
    },
    img: {
      default: ""
    },
    imgSize: null,
    show: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const curImg = ref([]);
    const show = ref(props.show);
    // const emit = defineEmits(["update:show"])
    watch(() => props.img, v => {
      console.log("img", v);
      let tempArr = [];
      if (v && Array.isArray(v)) {
        curImg.value = v;
      } else {
        tempArr[0] = v;
        curImg.value = tempArr;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(show, v => {
      /* 深层级变更状态所触发的回调 */
      if (v) {
        // emit("update:show", v)
      }
    });
    return (_ctx, _cache) => {
      const _component_Btn = _resolveComponent("Btn");
      const _component_viewer = _resolveComponent("viewer");
      const _component_Popup = _resolveComponent("Popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [props.img ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => show.value = !show.value, ["stop"])),
        class: _normalizeClass(["row col-center", __props.square ? _ctx.css.small_img : 'k-cursor-pointer']),
        style: _normalizeStyle({
          backgroundImage: __props.square ? `url(${__props.img})` : '',
          width: `${__props.imgSize}px`,
          height: `${__props.imgSize}px`
        })
      }, [__props.simple ? (_openBlock(), _createElementBlock("span", _hoisted_1, " 查看")) : (_openBlock(), _createElementBlock("span", _hoisted_2, [!__props.square ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: props.img,
        class: _normalizeClass(_ctx.css.img)
      }, null, 10, _hoisted_3)) : _createCommentVNode("", true)]))], 6)) : (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无")), _createVNode(_component_Popup, {
        title: "查看图片",
        bodyStyle: {
          'max-height': '100%'
        },
        show: show.value
      }, {
        footer: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(_ctx.css.close)
        }, [_createVNode(_component_Btn, {
          onClick: _cache[1] || (_cache[1] = $event => show.value = false),
          class: _normalizeClass(_ctx.css.btn_close)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        }, 8, ["class"])], 2)]),
        default: _withCtx(() => [_createElementVNode("div", {
          size: __props.size
        }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_viewer, {
          trigger: curImg.value
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curImg.value, (src, index) => {
            return _openBlock(), _createElementBlock("img", {
              src: src,
              style: {
                "max-height": "70vh"
              },
              key: index,
              class: "pointer",
              title: "点击查看大图，旋转，缩放"
            }, null, 8, _hoisted_7);
          }), 128))]),
          _: 1
        }, 8, ["trigger"])])], 8, _hoisted_5)]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
});